var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 293,
    viewBox: "0 0 293 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 293,
    rx: 4,
    fill: "#1E1E1E",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.86 137.833H155.167V135.14C155.167 134.42 154.58 133.833 153.86 133.833H153.82C153.087 133.833 152.5 134.42 152.5 135.14V137.833H149.82C149.1 137.833 148.513 138.42 148.5 139.14V139.18C148.5 139.913 149.087 140.5 149.82 140.5H152.5V143.18C152.5 143.9 153.087 144.5 153.82 144.487H153.86C154.58 144.487 155.167 143.9 155.167 143.18V140.5H157.86C158.58 140.5 159.167 139.913 159.167 139.193V139.14C159.167 138.42 158.58 137.833 157.86 137.833ZM151.167 143.18V141.833H149.82C149.113 141.833 148.447 141.553 147.94 141.06C147.447 140.553 147.167 139.887 147.167 139.14C147.167 138.66 147.3 138.22 147.527 137.833H136.5C135.033 137.833 133.833 139.033 133.833 140.5V156.5C133.833 157.967 135.033 159.167 136.5 159.167H152.5C153.967 159.167 155.167 157.967 155.167 156.5V145.46C154.767 145.687 154.313 145.833 153.807 145.833C152.353 145.82 151.167 144.633 151.167 143.18ZM137.833 156.5H151.113C151.673 156.5 151.98 155.86 151.633 155.42L147.7 150.513C147.433 150.167 146.913 150.18 146.647 150.527L143.167 155.167L141.033 151.953C140.767 151.58 140.22 151.553 139.94 151.927L137.3 155.433C136.967 155.873 137.287 156.5 137.833 156.5Z",
    fill: "#5F6C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/Add_image.6ac40882865f448f368f32801710a8db.svg";
export { ForwardRef as ReactComponent };